import { FC, Fragment, PropsWithChildren } from 'react';

import { DashboardLayout } from '@/features/layout/dashboard-layout';

import { ComponentLayout } from './component-layout';
import { LayoutFC } from './types/LayoutFC';

const layouts = {
  dashboard: DashboardLayout,
  component: ComponentLayout,
  none: Fragment,
};

export function setLayout({
  layoutType = 'dashboard',
  InnerLayout = Fragment,
  Page,
}: {
  layoutType?: keyof typeof layouts;
  InnerLayout?: FC<PropsWithChildren>;
  Page: LayoutFC<any>;
}): FC {
  const Layout = layouts[layoutType];
  // eslint-disable-next-line no-param-reassign
  Page.Layout = ({ children, ...rest }: any) => (
    <Layout {...rest}>
      <InnerLayout>{children}</InnerLayout>
    </Layout>
  );
  return Page;
}
